
import React from 'react'
import { ProductionStack as StackComponent } from './stacks'

import { GenericItem } from './generic'

export const ProductionItem = props => {
  return <GenericItem {...props} StackComponent={StackComponent} />
}

export default ProductionItem